import { createReducer } from '@reduxjs/toolkit';
import { removeImagesCache } from '../../Utils/Cache';
import { removeFaIconCache } from '@tools/Utils/Cache';
import { login, logout, setUserToken, setLoginDrawer } from '../actions/AccountActions';

const initState: AccountType = {
	error: '',
	loading: false,
	loggedIn: false,
	isLoginDrawerOpen: false,
	user: {
		ID: '',
		name: '',
		token: '',
		email: '',
		username: '',
	},
};

const AccountReducer = createReducer(initState, {
	//? Logout
	[logout.type]: (state, _) => {
		removeFaIconCache();
		removeImagesCache();
		window.user_token = undefined;
		return { ...state, user: null, loading: false, loggedIn: false, error: '', isLoginDrawerOpen: false };
	},

	//? Login
	[login.pending.type]: (state, { payload }) => {
		window.user_token = undefined;
		return { ...state, user: null, loading: true, loggedIn: false, error: '' };
	},
	[login.rejected.type]: (state, { payload }) => {
		window.user_token = undefined;
		return { ...state, user: null, loading: false, loggedIn: false, error: payload.error };
	},
	[login.fulfilled.type]: (state, { payload }) => {
		window.user_token = payload?.token;
		return { ...state, user: payload, loggedIn: true, loading: false, error: '' };
	},

	//? Login modal
	[setLoginDrawer.type]: (state, { payload }) => {
		return { ...state, isLoginDrawerOpen: payload };
	},

	//? set token
	[setUserToken.type]: (state, { payload }) => {
		window.user_token = payload;
		return { ...state, user: { ...state?.user!!, token: payload } };
	},
});

export type UserAccountType = null | {
	ID: string;
	name: string;
	email: string;
	token: string;
	username: string;
	status?: 'ACTIVE' | 'DISABLED';
	CLASS_NAME?: 'ML_SYSTEM_USER';
	role?: { isSuper?: boolean; items?: ROLE_ITEM[] };
};

export type AccountType = {
	error: string;
	loading: boolean;
	loggedIn: boolean;
	user: UserAccountType;
	isLoginDrawerOpen: boolean;
};

export type ROLE_ITEM =
	| 'INTRO_TO_ML'
	| 'CATEGORICAL_DATA'
	| 'NLP'
	| 'NUMERICAL_DATA'
	| 'HIERARCHICAL_DATA'
	| 'TEMPORAL_AND_ORDINAL_DATA'
	| 'VISUAL_STORY_TELLING'
	| 'GEOSPATIAL_DATA'
	| 'VISUALIZE_COMPARISONS'
	| 'SURVEY_DATA'
	| 'ALL';

export default AccountReducer;

export const ACCESSES = {
	ALL: {
		label: 'All',
		children: {
			INTRO_TO_ML: { label: 'Introduction to Machine Learning' },
			SUPERVISED_VS_UNSUPERVISED: { label: 'Supervises vs. Unsupervised Learning' },
			LINEAR_REGRESSION: { label: 'Linear Regression and Classification' },
			PRACTICAL_ML: { label: 'Practical Machine Learning Implementation' },
			GENERATIVE_MODELS: { label: 'Generative Models' },
			DECISION_TREE_ENSEMBLE: { label: 'Decision Trees and Ensembles' },
			NEURAL_NETWORKS_I: { label: 'Neural Networks I' },
			NEURAL_NETWORKS_II: { label: 'Neural Networks II' },
			SVM: { label: 'Support Vector Machines (SVM)' },
			NLP_I: { label: 'Natural Language Processing I' },
			NLP_II: { label: 'Natural Language Processing II' },
		},
	},
};
